import React, { useContext } from "react";
import { Badge, Button, LegacyCard as Card, Text, List, InlineStack } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { useLocation } from "react-router-dom";

const Heading = ({ name = "", monthlyFee = "", isActive = false, isPopular = false, isHidePrice = false }) => {
  const { cms } = useContext(PrivateContext);

  return (
    <InlineStack blockAlign="center" align="space-between" wrap={false}>
      <Text variant="headingSm" as="h1">
        <InlineStack>
          <div>
            {name.toUpperCase()}
            {isPopular && <Badge status={constant.SUCCESS}>{cms("label.popular")}</Badge>}
            {isActive && <Badge status={constant.INFO}>{cms("label.active")}</Badge>}
          </div>
        </InlineStack>
      </Text>
      {!isHidePrice && <Text variant="heading2xl" as="p">{`$${monthlyFee}/m`}</Text>}
      {isHidePrice && (
        <Text variant="heading2xl" as="p">
          3% of total order value / month
        </Text>
      )}
    </InlineStack>
  );
};

const PlanCard = ({ plan = {}, callback = () => {}, activePlan = "", submitLoading = false }) => {
  const { cms } = useContext(PrivateContext);
  const location = useLocation();
  const {
    sections = [],
    feature: features = [],
    isPopular,
    labelVendor,
    maxProducts,
    maxVendors,
    monthlyFee = "",
    name = "",
  } = plan;
  const isUpdatePlanPage = location?.pathname === "/update/plan";

  const buttonText = isUpdatePlanPage ? cms("button.update") : cms("button.select");

  const isActivePlan = activePlan === plan.code;
  const isStartUpPlan = plan.code === "startup";
  const isDisabled = isUpdatePlanPage ? isActivePlan : !!activePlan;

  return (
    <Card>
      <Card.Section>
        <Heading
          name={name}
          monthlyFee={monthlyFee}
          isActive={isActivePlan}
          isPopular={isPopular}
          isHidePrice={isStartUpPlan}
        />
      </Card.Section>
      <Card.Section>
        <List>
          {!isStartUpPlan && [
            <List.Item key="planProduct">{`${cms("label.product")}: ${maxProducts}`}</List.Item>,
            <List.Item key="planVendor">{`${cms("label.vendor")}: ${labelVendor || maxVendors}`}</List.Item>,
          ]}
          {features &&
            features.map((feature) => {
              return <List.Item key={feature}>{feature}</List.Item>;
            })}
          {sections &&
            sections.length &&
            sections.map((section, index) => {
              const { title, content = [] } = section;
              return [
                <List.Item key={`section${index}`}>{title}</List.Item>,
                <List>
                  {content &&
                    content.length &&
                    content.map((contentText, index) => {
                      return <List.Item key={`sectionContent${index}`}>{contentText}</List.Item>;
                    })}
                </List>,
              ];
            })}
        </List>
        <br />
        <Button variant="primary" fullWidth onClick={() => callback()} disabled={isDisabled} loading={submitLoading}>
          {buttonText}
        </Button>
      </Card.Section>
    </Card>
  );
};

export default PlanCard;
